export default __webpack_public_path__ + "static/media/more-white-icon.1694c350.svg";